import VueShortkey from 'vue-shortkey'

export default ({ Vue }) => {
  Vue.use(VueShortkey, { prevent: ['input', 'textarea', '[contenteditable]'] })
}
